(() => {
  const arrow = '<svg class="tsg-arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M5 19 19 5M5 5h14v14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function setup(root) {
    root.querySelectorAll('a,button').forEach(link => {
      const walk = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walk.nextNode()) if (walk.currentNode.textContent.includes('↗')) nodes.push(walk.currentNode);
      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        node.textContent.split(/↗[\uFE0E\uFE0F]?/).forEach((part, i) => {
          if (i) {
            const template = document.createElement('template');
            template.innerHTML = arrow;
            fragment.append(template.content.cloneNode(true));
          }
          fragment.append(document.createTextNode(part));
        });
        node.replaceWith(fragment);
      });
    });
    root.querySelectorAll('[data-services-nav]').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const toggle = nav.querySelector('.tsg-services-toggle');
      const list = nav.querySelector('.tsg-services-submenu');
      const setOpen = open => {
        toggle.setAttribute('aria-expanded', String(open));
        list.hidden = !open;
      };
      let closeTimer;
      const canHover = () => nav.closest('.header__inline-menu') && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      nav.addEventListener('pointerenter', () => {
        clearTimeout(closeTimer);
        if (canHover()) setOpen(true);
      });
      nav.addEventListener('pointerleave', () => {
        if (canHover()) closeTimer = setTimeout(() => {
          if (!nav.contains(document.activeElement)) setOpen(false);
        }, 160);
      });
      toggle.addEventListener('click', event => {
        event.stopImmediatePropagation();
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      }, true);
      nav.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !list.hidden) {
          event.preventDefault();
          event.stopPropagation();
          setOpen(false);
          toggle.focus();
        }
      });
      nav.addEventListener('focusout', event => { if (!nav.contains(event.relatedTarget)) setOpen(false); });
      document.addEventListener('click', event => { if (!nav.contains(event.target)) setOpen(false); });
      const drawer = nav.closest('header-drawer > details');
      if (drawer) drawer.addEventListener('toggle', () => { if (!drawer.open) setOpen(false); });
    });
    root.querySelectorAll('[data-tsg-value]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const buttons = section.querySelectorAll('[data-value-mode]');
      const update = mode => {
        const active = mode === 'tsg';
        section.dataset.mode = mode;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.valueMode === mode)));
        section.querySelectorAll('.tsg-orbit-task').forEach(task => task.setAttribute('aria-hidden', String(active)));
        section.querySelectorAll('.tsg-simple-margin').forEach(item => item.setAttribute('aria-hidden', String(active)));
        section.querySelector('.tsg-saved-space').setAttribute('aria-hidden', String(!active));
        section.querySelector('[data-bar-label]').textContent = active ? 'With TSG' : 'Traditional cost';
        section.querySelector('[data-cost-label]').innerHTML = active ? 'Lower cost.<br>More kept.' : 'More layers.<br>Higher cost.';
        section.querySelector('[data-cost-explanation]').textContent = active ? 'Factory-direct sourcing cuts out layers of markup.' : 'Retail and distribution markups add to your price.';
        section.querySelector('[data-value-summary]').textContent = active ? 'Lower product costs. All six steps managed by TSG.' : 'More layers in the price. More suppliers to coordinate.';
      };
      buttons.forEach(button => button.addEventListener('click', () => update(button.dataset.valueMode)));
      update(section.dataset.mode);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
